import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import * as wActs from "../actions/website-actions";
import { Link } from 'react-router-dom';
const lettersmap = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const letters = lettersmap.split("");

const lStyle = {border: "solid 1px #454545", display: "inline-block", padding: "3px", backgroundColor: "#e6e9ed", margin: "2px", fontSize: "16px", lineHeight: "18px"}
const sectHdr = {background: "#e6e9ed", textAlign: "left", padding: "20px", marginTop: "3px", fontSize: "13px"}
const defHdr = {textAlign: "left", padding: "7px", marginTop: "2px", fontSize: "13px"}

class SiteMap extends Component {

  handleClick(e) {
    window.ScrollTop();
  }

  getPath(url) {
    let reg = /.+?\:\/\/.+?(\/.+?)?(?:#|\?|)?$/;
    let path = reg.exec(url)[1];
    if(wActs.isNullOrEmpty(path)) { path ="/" }
    return path;
  }

  handleLetter(e, l) {
    e.preventDefault();
    this.props.dispatch(wActs.getSiteMap(window.location.href, l));
  }



  render() {

    let list = this.props.SiteMap.Loaded && !wActs.isNullOrUndefined(this.props.SiteMap.ApiResult.Result) ?  this.props.SiteMap.ApiResult.Result : [];
    //console.log(list.Groups)
    return (
      <div className={`main`}>
        <div className="inner">
          <div className="container" style={{marginBottom: "200px"}}>



          {!this.props.SiteMap.Loaded &&
          <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
            <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
          </p>
          }

          {this.props.SiteMap.Loaded &&
          <React.Fragment>
            {list.Groups.map((gv,gi) => {
              return (
                <React.Fragment key={"group-" + gi}>
                  <div className="title" style={{marginTop: "1em", marginBottom: "1em",fontSize: "30px"}}>{gv.Title}</div>
                  {gv.Rows.map((rv,ri) => {
                    let title = rv.Title;
                    let out = [<div key={"row1-" + ri} className="col_50" style={{display: "inline-block"}}><Link className={"sitemapLink"} title={rv.AltText} to={this.getPath(rv.Url)}>{title}</Link></div>];
                    if(rv.Rows) {
                      let sub = rv.Rows.map((rrv,rri)=> {
                        let title = rrv.Title;
                        return <li key={"row2-" + rri} className="col_50 links" style={{display: "block"}}><Link className={"sitemapLink"} title={rrv.AltText} to={this.getPath(rrv.Url)}>{title}</Link></li>;
                      });
                      out = (
                        (
                          <div key={"row1-" + ri} className="col_50" style={{display: "inline-block"}}>
                            <Link className={"sitemapLink"} title={rv.AltText} to={this.getPath(rv.Url)}>{title}</Link>
                            <ul>
                              {sub}
                            </ul>
                          </div>
                        ))
                    }
                    return out;
                  })}
                </React.Fragment>
              );
            })}
          </React.Fragment>
          }
        </div>
      </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    SiteMap: state.Website.SiteMap
  };
}

export default connect(mapStateToProps)(SiteMap);
